<template>
  <div class="about">
    <div class="banner"></div>

    <div class="common one">
      <div class="wrapper">
        <div class="left"></div>
        <div class="right">
          <div>公司概况</div>
          <div>Company profile</div>
          <div>
            徐州乐分享软件科技有限公司总部位于江苏省徐州市中国矿业大学国家大学科技园<br>
            截至目前，研发出轻松教学题库系统、web版题库系统、Word批量处理大师等软件，是一家具备完善的研发、实施能力的优质企业。<br>
            在题库考试、教育软件开发和office处理软件开发上一直保持领先，在行业内有较高知名度。
          </div>
        </div>
      </div>
    </div>
    <div class="common two">
      <div class="wrapper">
        <div>
          <div>
            <img :src="icon1" alt="">
          </div>
          <div class="title">专业</div>
          <div class="intro">15年专业历程，资深行业领跑者</div>
        </div>
        <div>
          <div>
            <img :src="icon2" alt="">
          </div>
          <div class="title">执着</div>
          <div class="intro">产品15年的研究与打磨最终完成</div>
        </div>
        <div>
          <div>
            <img :src="icon3" alt="">
          </div>
          <div class="title">分享</div>
          <div class="intro">互帮互助才是成功之道</div>
        </div>
      </div>
    </div>
    <div class="common three">
      <div class="wrapper">
        <div>发展状况</div>
        <div>努力与成绩并存</div>
        <!-- <ul class="list">
          <li @mouseover="over(1)" @mouseleave="leave(1)">
            <div>
              <img :src="curIndex === 1 ? img1 : img1_status" alt="">
            </div>
            <div>公司发展状况</div>
            <div>公司发展状况:公司的发展速 度,有何成绩,有何荣誉称号等;</div>
          </li>
          <li @mouseover="over(2)" @mouseleave="leave(2)">
            <div>
              <img :src="curIndex === 2 ? img2 : img2_status" alt="">
            </div>
            <div>公司发展状况</div>
            <div>公司发展状况:公司的发展速 度,有何成绩,有何荣誉称号等;</div>
          </li>
          <li @mouseover="over(3)" @mouseleave="leave(3)">
            <div>
              <img :src="curIndex === 3 ? img3 : img3_status" alt="">
            </div>
            <div>公司发展状况</div>
            <div>公司发展状况:公司的发展速 度,有何成绩,有何荣誉称号等;</div>
          </li>
        </ul> -->
        <div class="block">
        <el-timeline>
          <el-timeline-item timestamp="2020/5" placement="top">
            <el-card>
              <p>网络版和web版题库、在线考试系统全新发布（个人及团队协作、各个行业）</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2018/8" placement="top">
            <el-card>
              <p>网络版和web版题库全新架构设计及基础代码，多次重构</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2018/6" placement="top">
            <el-card>
              <p>发布全新个人版（全新开发），确保易用、快捷、专业、提升智能化</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2015/5" placement="top">
            <el-card>
              <p>题库软件发布web版</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2012/9" placement="top">
            <el-card>
              <p>题库软件发布网络版</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2012/3" placement="top">
            <el-card>
              <p>个人版题库软件全新改版为全兼容Word</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2009/6" placement="top">
            <el-card>
              <p>发布个人版题库软件</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2008/10" placement="top">
            <el-card>
              <p>发布PPT批量处理大师，不断优化升级，至今为6.0版，26个大类功能</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2006/5" placement="top">
            <el-card>
              <p>发布Word批量处理大师，不断优化升级，至今为9.0.9版，39个大类功能</p>
            </el-card>
          </el-timeline-item>         
        </el-timeline>
      </div>
      </div>
    </div>
    <div class="common four">
      <div class="wrapper">
        <div>联系我们</div>
        <div>售后服务:主要是公司售后服务的承诺。</div>
        <div>
          <div><i class="el-icon-phone"></i>18652255099</div>
          <div>请拨打联系电话</div>
        </div>
        <div>
          <ul class="list">
            <li>
              <div class="str">您的姓名</div>
              <el-input v-model="username" placeholder="请输入姓名"></el-input>
            </li>
            <li>
              <div class="str">联系方式</div>
              <el-input v-model="contact" placeholder="请输入联系方式"></el-input>
            </li>
            <li>
              <div class="str">电子邮箱</div>
              <el-input v-model="email" placeholder="请输入电子邮箱"></el-input>
            </li>
          </ul>
        </div>
        <div>
          <div class="str">您的留言</div>
          <el-input
            type="textarea"
            :rows="10"
            placeholder="请输入留言"
            v-model="text">
          </el-input>
        </div>
        <div class="btn">
          <el-button type="primary" @click="submit">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      img1_status: require('@/assets/icon_zk@2x.png'),
      img1: require('@/assets/icon_id@2x.png'),
      img2_status: require('@/assets/icon_ll@2x.png'),
      img2: require('@/assets/icon_qw@2x.png'),
      img3_status: require('@/assets/icon_iu1.png'),
      img3: require('@/assets/icon_iu@2x.png'),
      icon1: require('@/assets/icon_1@2x.png'),
      icon2: require('@/assets/icon_2@2x.png'),
      icon3: require('@/assets/icon_3@2x.png'),
      username: '',
      contact: '',
      email: '',
      text: '',
      curIndex: -1
    }
  },
  created(){
    
  },
  methods: {
    submit(){
      this.$alert('抱歉！乐分享官网正在升级，该功能暂时不开放！请直接联系QQ710726095', '提示', {
        confirmButtonText: '确定',
        lockScroll: false,
        callback: () => {
          
        }
      });
    },
    over(index){
      this.curIndex = index;
    },
    leave(){
      this.curIndex = -1;
    }
  }
}
</script>
<style lang="less">
  .about{
    .banner{
      height: 730px;
      background: #198AF7 url('../assets/img_gywm.png') no-repeat center center;
      background-size: auto 100%;
    }
    .common{
      background-color: #FCFCFC;
      .wrapper{
        width: 1200px;
        margin: 0 auto;
      }
    }
    .one{
      .wrapper{
        padding: 63px 0;
        box-sizing: border-box;
        display: flex;
        height: 700px;
        .left{
          flex: 1;
          background: url('../assets/img_aboutus@2x.png') no-repeat center top;
          background-size: contain;
        }
        .right{
          flex: 1;
          margin-left: 100px;
          div{
            &:nth-of-type(1){
              font-size: 36px;
              color: #F88927;
            }
            &:nth-of-type(2){
              color: #8F8F8F;
              font-size: 20px;
            }
            &:nth-of-type(3){
              font-size: 20px;
              margin-top: 30px;
            }
          }
        }
      }
    }
    .two{
      height: 330px;
      background: url('../assets/img_jj@2x.png') no-repeat center center;
      background-size: auto 100%;
      .wrapper{
        display: flex;
        height: 100%;
        justify-content: space-around;
        >div{
          text-align: center;
          color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 356px;
          .title{
            font-size: 30px;
            margin: 25px 0;
          }
          .intro{
            font-size: 20px;
          }
        }
      }
    }
    .three{
      text-align: center;
      background-color: #fff;
      .wrapper{
        padding: 100px 0;
        >div{
          &:nth-of-type(1){
            font-size: 36px;
          }
          &:nth-of-type(2){
            font-size: 20px;
            color: #F88927;
            margin: 30px 0;
            position: relative;
            padding-bottom: 15px;
            &::after{
              display: inline-block;
              position: absolute;
              left: 50%;
              bottom: 0;
              transform: translateX(-50%);
              content: '';
              height: 2px;
              width: 105px;
              background-color: #F88927;
            }
          }
        }
        .block{
          text-align: left;
        }
        // .list{
        //   display: flex;
        //   justify-content: center;
        //   li{
        //     width: 356px;
        //     height: 409px;
        //     box-sizing: border-box;
        //     padding: 47px;
        //     cursor: pointer;
        //     &:hover{
        //       background:rgba(255,255,255,1);
        //       box-shadow:0px 4px 16px 0px rgba(215, 86, 135, 0.35);
        //       border-radius:8px;
        //       transition: all 0.6s;
        //       transform: scale(1.04);
        //     }
        //     >div{
        //       &:nth-of-type(2){
        //         font-size: 30px;
        //         margin: 20px 0 35px 0;
        //       }
        //       &:nth-of-type(3){
        //         font-size: 20px;
        //         color: #8F8F8F;
        //       }
        //     }
        //   }
        // }
      }
    }
    .four{
      text-align: center;
      padding: 100px 0;
      .wrapper{
        width: 950px;
        >div{
          &:nth-of-type(1){
            font-size: 36px;
          }
          &:nth-of-type(2){
            font-size: 20px;
            color: #8F8F8F;
            margin: 30px 0;
          }
          &:nth-of-type(3){
            div{
              &:nth-of-type(1){
                width: 224px;
                height: 60px;
                font-size: 24px;
                color: #fff;
                border-radius:4px;
                line-height: 60px;
                background-color: #F88927;
                display: inline-block;
              }
              &:nth-of-type(2){
                font-size: 18px;
                color: #8F8F8F;
                margin-top: 18px;
              }
            }
          }
          &:nth-of-type(4){
            font-size: 18px;
            margin-top: 50px;
            .list{
              text-align: left;
              display: flex;
              li{
                flex: 1;
                margin-right: 30px;
                .str{
                  margin-bottom: 10px;
                }
                &:nth-last-of-type(1){
                  margin-right: 0;
                }
              }
            }
          }
          &:nth-of-type(5){
            font-size: 18px;
            text-align: left;
            margin-top: 30px;
            .str{
              margin-bottom: 10px;
            }
          }
        }
        .btn{
          text-align: right;
          margin-top: 30px;
          .el-button{
            background: #49BDEE;
            width: 140px;
          }
        }
      }
    }
  }
</style>
